/** Adds `?area=<id>` to an internal Tvarkos path, so a link keeps the sphere the person is working in. */
export default function withAreaQuery(path: string, areaId?: string | null): string {
  return areaId ? `${path}?area=${encodeURIComponent(areaId)}` : path;
}
